import { program } from "../redeemer";

program.parse(process.argv);
